import { PerUnitDiscountComponent } from '@domains/billing-settings/priv/CustomerDiscount/discounts/per-unit/PerUnitDiscount'
import dayjs from 'dayjs'
import { DiscountModifier, DiscountType } from '../api/api'
import { useCreateCustomerDiscount } from '../api/queries'
import type { CreateCustomerDiscountPlugin, CreateCustomerDiscountPluginComponentProps } from '../components/CreateCustomerDiscountDialog'
import type { PerUnitDiscountForm } from '../discounts/per-unit'

interface PerUnitFactoryProps extends CreateCustomerDiscountPluginComponentProps {}

export const PerUnitDiscountFactory = (props: PerUnitFactoryProps) => {
  const { mutate: createCustomerDiscount, isLoading } = useCreateCustomerDiscount(props.customerId)

  const handleCreatePerUnitDiscount = (data: PerUnitDiscountForm) => {
    switch (data.discountModifier) {
      case DiscountModifier.PERCENTAGE: {
        return createCustomerDiscount(
          {
            billableId: props.productId,
            discountType: {
              type: DiscountType.PerUnitDiscount,
              modifier: data.discountModifier,
              percentageValue: data.discountValue,
            },
            expirationDate: data.expirationDate ? dayjs(data.expirationDate).format('YYYY-MM-DD') : undefined,
          },
          { onSuccess: () => props.onCreatedDiscount() },
        )
      }

      case DiscountModifier.ABSOLUTE: {
        return createCustomerDiscount(
          {
            billableId: props.productId,
            discountType: {
              type: DiscountType.PerUnitDiscount,
              modifier: data.discountModifier,
              absoluteAmount: {
                value: data.discountValue,
                currency: props.currency,
              },
            },
            expirationDate: data.expirationDate ? dayjs(data.expirationDate).format('YYYY-MM-DD') : undefined,
          },
          { onSuccess: () => props.onCreatedDiscount() },
        )
      }
    }
  }

  return <PerUnitDiscountComponent isPatching={isLoading} currency={props.currency} onCreatePerUnitDiscount={handleCreatePerUnitDiscount} />
}

export class PerUnitDiscountPlugin implements CreateCustomerDiscountPlugin {
  name: string = 'Per unit'
  getComponent() {
    return PerUnitDiscountFactory
  }
  supports(discountType: string) {
    return discountType === 'Per unit'
  }
}
